<div class="companysection bg-secondary-subtle px-3 px-md-5 py-5">
  <div class="container-fluid darkbluebackground px-3 px-md-5 py-5 rounded-3">
    <h2 class="text-center text-white h3 fw-bold mb-5">TRUSTED BY COMPANIES GLOBALLY</h2>
    <a queryParamsHandling="merge" routerLink="/company/customers">
      <div class="row g-3">
        <div class="col-6 col-md-3">
          <div class="pdfimg-container">
            <img [ngSrc]="'assets/images/customerlogos/webp/' + item[0].imgsrc" class="img-fluid pdfimg partnerlogo"
              [alt]="item[0].imgsrc" width="150" height="65" loading="lazy">
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="pdfimg-container">
            <img [ngSrc]="'assets/images/customerlogos/webp/' + item[1].imgsrc" class="img-fluid pdfimg partnerlogo"
              [alt]="item[1].imgsrc" width="150" height="65" loading="lazy">
          </div>
        </div>
        <div *ngIf="item[2]" class="col-6 col-md-3">
          <div class="pdfimg-container">
            <img [ngSrc]="'assets/images/customerlogos/webp/' + item[2].imgsrc" class="img-fluid pdfimg partnerlogo"
              [alt]="item[2].imgsrc" width="150" height="65" loading="lazy">
          </div>
        </div>
        <div *ngIf="item[3]" class="col-6 col-md-3">
          <div class="pdfimg-container">
            <img [ngSrc]="'assets/images/customerlogos/webp/' + item[3].imgsrc" class="img-fluid pdfimg partnerlogo"
              [alt]="item[3].imgsrc" width="150" height="65" loading="lazy">
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
